import { IconContent } from '@icons';

export const bellFilled: IconContent = {
    // eslint-disable-next-line max-len
    sm: '<path d="M6.938 14.06c.291.293.644.44 1.058.44.413 0 .767-.146 1.062-.438A1.44 1.44 0 0 0 9.5 13h-3c0 .412.146.766.438 1.06ZM2 12h12v-1h-1l-.356-5.642a4.653 4.653 0 0 0-9.288 0L3 11H2v1Z" />',
    md: '<path d="m18.23 8.59.765 8.41H20v1H4v-1h1.005l.764-8.41a6.256 6.256 0 0 1 12.461 0Zm-11.465.09L6.01 17l.756-8.32Zm5.228 12.57c-.62 0-1.15-.22-1.587-.66A2.175 2.175 0 0 1 9.75 19h4.5c0 .625-.221 1.156-.663 1.594a2.184 2.184 0 0 1-1.594.656Z" />',
};
